import React, { useState, useEffect } from 'react'
import 'react-loading-skeleton/dist/skeleton.css'
import { Check, Trash, Plus, CreditCard, ShieldCheck } from 'react-bootstrap-icons'
import {
  useSession,
  useLanguage
} from '~components'

import { PaymentOptionPowerTranz as PaymentOptionPowerTranzController } from '../PaymentOptionPowerTranzController'

import { useTheme } from 'styled-components'
import { FacCardForm } from '../FacCardForm'

import {
  NotFoundSource,
  Confirm,
  Modal
} from '~ui'

import {
  OptionStripeContainer,
  WarningMessage,
  CardItem,
  CardItemContent,
  CardItemActions,
  AddNewCard,
  CardItemActionsWrapper,
  BlockLoading,
  CvvInputWrapper,
  NoCardsMessage,
  PaymentHeader
} from './styles'

const PaymentOptionPowerTranzUI = (props) => {
  const {
    cardsList,
    handleCardClick,
    handlePay,
    handleChangeFacCard,
    handleChangeFacCardName,
    handleChangeFacMonth,
    handleChangeFacYear,
    handleChangeFacCvv,
    facCardData,
    addCartOpen2,
    redSysDeleteCardnew,
    setAddCardOpenfnc,
    addCartOpen,
    handelChangeNewCardPlaceOrder,
    onSelectCard
  } = props
  const [{ token, user }] = useSession()
  const [, t] = useLanguage()
  const theme = useTheme()
  const [confirm, setConfirm] = useState({ open: false, content: null, handleOnAccept: null })
  const [selectedCardId, setSelectedCardId] = useState(null)
  const [cvvValues, setCvvValues] = useState({})

  const _handleNewCard = (card) => {
    setAddCardOpenfnc(false)
  }

  const handleDeleteCard = (card) => {
    setConfirm({
      open: true,
      content: t('QUESTION_DELETE_CARD', 'Are you sure that you want to delete the card?'),
      handleOnAccept: () => {
        redSysDeleteCardnew(card)
        setConfirm({ ...confirm, open: false })
      }
    })
  }

  const handleCvvChange = (cardId, value) => {
    // Only allow numbers and max 4 digits
    const sanitizedValue = value.replace(/\D/g, '').slice(0, 4)
    setCvvValues(prev => ({ ...prev, [cardId]: sanitizedValue }))
    window.localStorage.setItem('card_cvv', sanitizedValue)
  }

  const handleSelectCard = (card) => {
    setSelectedCardId(card.id)
    handleCardClick(card)

    // Store CVV if already entered
    if (cvvValues[card.id]) {
      window.localStorage.setItem('card_cvv', cvvValues[card.id])
    }

    // Derive last4 from card_number (as shown in card list), or fallback to dedicated fields
    const last4 = card?.card_number?.replace(/\s/g, '').slice(-4) || card.customerDatalast4 || card.last4

    onSelectCard && onSelectCard({
      id: card.id,
      type: 'card',
      card: {
        brand: card.brand,
        last4
      }
    })
  }

  const getIconCard = (brand = '') => {
    const value = brand?.toLowerCase() || ''
    switch (value) {
      case 'visa':
        return theme?.images?.general?.visa
      case 'mastercard':
        return theme?.images?.general?.mastercard
      case 'amex':
      case 'american express':
        return theme?.images?.general?.amex
      default:
        return theme?.images?.general?.credit
    }
  }

  useEffect(() => {
    if (addCartOpen2 === true) {
      window.localStorage.setItem('facCardData', JSON.stringify(facCardData))
      window.localStorage.setItem('facNewCard', 'yes')
      handelChangeNewCardPlaceOrder(true)
    } else {
      window.localStorage.setItem('facCardData', '')
      window.localStorage.setItem('facNewCard', '')
    }
  }, [addCartOpen2])

  // Auto-select first card if available
  useEffect(() => {
    if (!cardsList.loading && cardsList.cards && cardsList.cards.length > 0 && !selectedCardId) {
      const firstCard = cardsList.cards[0]
      handleSelectCard(firstCard)
    }
  }, [cardsList.loading, cardsList.cards])

  return (
    <>
      {props.beforeElements?.map((BeforeElement, i) => (
        <React.Fragment key={i}>
          {BeforeElement}
        </React.Fragment>))}
      {props.beforeComponents?.map((BeforeComponent, i) => (
        <BeforeComponent key={i} {...props} />))}

      <OptionStripeContainer>
        {/* Payment Header with Logos */}
        <PaymentHeader>
          <div className='logo-container'>
            <img
              src='https://res.cloudinary.com/acuity/image/upload/v1673438464/fac_logo_xg4nqv.png'
              alt='PowerTranz'
            />
            <img
              src='https://res.cloudinary.com/acuity/image/upload/v1673438469/download_h10t8j.jpg'
              alt='Secure Payment'
            />
          </div>
          <div className='secure-badge'>
            <ShieldCheck />
            <span>{t('SECURE_PAYMENT', 'Secure Payment')}</span>
          </div>
        </PaymentHeader>

        {!token && (
          <WarningMessage>
            {t('NEED_LOGIN_TO_USE', 'Sorry, you need to login to use this method')}
          </WarningMessage>
        )}

        {token && cardsList.loading && (
          <>
            {[...Array(3).keys()].map(i => (
              <BlockLoading key={i} />
            ))}
          </>
        )}

        {token && !cardsList.loading && cardsList.cards && cardsList.cards.length === 0 && (
          <NoCardsMessage>
            <div className='icon'>
              <CreditCard />
            </div>
            <span>{t('NO_SAVED_CARDS', 'No saved cards yet')}</span>
          </NoCardsMessage>
        )}

        {token && cardsList.error && cardsList.error.length > 0 && (
          <NotFoundSource
            content={cardsList?.error[0]?.message || cardsList?.error[0]}
          />
        )}

        {token && !cardsList.loading && cardsList.cards && cardsList.cards.length > 0 && (
          <>
            {cardsList?.cards?.map((card, i) => (
              <CardItem
                key={card.id || i}
                onClick={() => handleSelectCard(card)}
                isCursor
                isSelected={selectedCardId === card.id}
              >
                <CardItemContent isSelected={selectedCardId === card.id}>
                  <div className='radio-check'>
                    {selectedCardId === card.id && <Check />}
                  </div>
                  <div className='card-icon'>
                    <img src={getIconCard(card?.brand)} alt={card?.brand || 'Card'} />
                  </div>
                  <div className='card-details'>
                    <span className='card-number'>
                      •••• •••• •••• {card?.card_number?.replace(/\s/g, '').slice(-4) || '****'}
                    </span>
                    <span className='card-brand'>
                      {card?.brand || t('CREDIT_CARD', 'Credit Card')}
                    </span>
                  </div>
                </CardItemContent>

                <CardItemActions>
                  {selectedCardId === card.id && (
                    <CvvInputWrapper onClick={(e) => e.stopPropagation()}>
                      <label>{t('CVV', 'CVV')}</label>
                      <input
                        type='password'
                        inputMode='numeric'
                        maxLength='4'
                        placeholder='•••'
                        value={cvvValues[card.id] || ''}
                        onChange={(e) => handleCvvChange(card.id, e.target.value)}
                        autoComplete='off'
                      />
                    </CvvInputWrapper>
                  )}
                  <CardItemActionsWrapper>
                    <button
                      className='delete-btn'
                      onClick={(e) => {
                        e.stopPropagation()
                        handleDeleteCard(card)
                      }}
                    >
                      <Trash />
                    </button>
                  </CardItemActionsWrapper>
                </CardItemActions>
              </CardItem>
            ))}
          </>
        )}

        {token && !cardsList.loading && (
          <AddNewCard onClick={() => setAddCardOpenfnc(true)}>
            <span>
              <Plus />
              {t('ADD_NEW_CARD', 'Add new card')}
            </span>
          </AddNewCard>
        )}

        <Modal
          title={t('ADD_NEW_CARD', 'Add new card')}
          className='modal-info'
          open={addCartOpen && !addCartOpen2}
          onClose={() => setAddCardOpenfnc(false)}
          width='100%'
          maxWidth='550px'
          padding='30px 24px'
        >
          <FacCardForm
            userid={user?.id}
            businessId={props.businessId}
            requirements={props.clientSecret}
            onCancel={() => setAddCardOpenfnc(false)}
            handlePay={(saveForFuture) => handlePay(saveForFuture)}
            handleChangeFacCard={() => handleChangeFacCard()}
            handleChangeFacCardName={() => handleChangeFacCardName()}
            handleChangeFacMonth={() => handleChangeFacMonth()}
            handleChangeFacYear={() => handleChangeFacYear()}
            handleChangeFacCvv={() => handleChangeFacCvv()}
            facCardData={facCardData}
            onNewCard={_handleNewCard}
          />
        </Modal>

        <Confirm
          title={t('CARD', 'Card')}
          content={confirm.content}
          acceptText={t('ACCEPT', 'Accept')}
          open={confirm.open}
          onClose={() => setConfirm({ ...confirm, open: false })}
          onCancel={() => setConfirm({ ...confirm, open: false })}
          onAccept={confirm.handleOnAccept}
          closeOnBackdrop={false}
        />
      </OptionStripeContainer>

      {props.afterComponents?.map((AfterComponent, i) => (
        <AfterComponent key={i} {...props} />))}
      {props.afterElements?.map((AfterElement, i) => (
        <React.Fragment key={i}>
          {AfterElement}
        </React.Fragment>))}
    </>
  )
}

export const PaymentOptionPowerTranz = (props) => {
  const paymentOptionPowerTranzProps = {
    ...props,
    UIComponent: PaymentOptionPowerTranzUI
  }
  return (
    <PaymentOptionPowerTranzController {...paymentOptionPowerTranzProps} />
  )
}
